import { css } from '@microsoft/fast-element';

export const RightSideModalStyles = css`
  :host {
    position: relative;
  }

  .right-dialog {
    --dialog-height: calc(100% - 18px);
    --dialog-width: 554px;
    --fill-color: var(--neutral-layer-3);
  }

  .right-dialog::part(positioning-region) {
    justify-content: end;
  }

  .right-dialog::part(control) {
    top: 0;
    margin-top: 16px;
    margin-right: 16px;
    position: relative;
    border: 1px solid var(--border-1);
  }

  .right-dialog .header {
    height: 56px;
    font-size: 18px;
    color: var(--white);
    border-bottom: 1px solid var(--border-1);
    display: flex;
    align-items: center;
    padding: 0 0 0 16px;
  }

  .right-dialog .footer {
    display: flex;
    justify-content: end;
    background: var(--modal-footer-bg);
    padding: 25px 16px;
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
  }

  .right-dialog .footer ::slotted(zero-button) {
    margin: 0 4px;
    font-size: 13px;
    height: 36px;
  }

  .closing-icon {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
    position: absolute;
    right: 15px;
    top: 12px;
  }

  .closing-icon:hover {
    background: var(--button-hover-bg);
  }

  .closing-icon::part(control):focus-visible {
    border: none;
    box-shadow: none;
  }

  .closing-icon:hover svg path {
    fill: var(--white);
  }

  .structured-chat.right-dialog::part(control) {
    top: 75px;
    right: 65px;
    height: calc(100% - 78px);
    margin: 0;
  }

  .user-modal.right-dialog::part(control) {
    top: 75px;
    right: 65px;
    height: calc(100% - 78px);
    margin: 0;
  }

  .knowledge-block-modal.right-dialog::part(control) {
    top: 75px;
    right: 65px;
    height: calc(100% - 78px);
    margin: 0;
  }

  .close-popup {
    position: static;
  }

  .header-left {
    background: transparent;
    border: none;
    height: 32px;
    margin: 0;
    min-width: 32px;
  }
`;
